import { z } from 'zod';

const RequiredPL = z.object({
  pl: z.string().min(1, 'Wpisz poprawną wartość.{1}'),
});

const AnyLocales = z.record(z.string(), z.string());
export const TranslationSchema = z.intersection(RequiredPL, AnyLocales);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createTranslationSchema = (errMsg: string, maxLen = 2000) => z.object({
  pl: z.string().min(1, errMsg).max(maxLen, `Maksymalna liczba znaków to ${maxLen}`),
}).refine((val) => !!val.pl?.trim(), {
  message: errMsg,
  path: ['pl'],
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createTranslationSchemaOptional = (
  errMsg: string,
  maxLen = 2000,
) => z.intersection(
  z.object({
    pl: z.string()
      .max(maxLen, `Maksymalna liczba znaków to ${maxLen}`).optional(),
  }).optional(),
  z.record(z.string(), z.string()).optional(),
);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createTranslationFileObjectSchema = (
  errMsg: string,
) => z.intersection(
  z.object({
    pl: z.string()
      .min(1, errMsg),
  }),
  z.record(z.string(), z.string()),
);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createTranslationFileObjectSchemaOptional = () => z.intersection(
  z.object({
    pl: z.string()
      .optional(),
  }).optional(),
  z.record(z.string(), z.string()).optional(),
);

export const phoneRegex = /^(?:\+\d{2}\s\d{3}\s\d{3}\s\d{3}|\+\d{2}\s\d{3}\s\d{2}\s\d{2}|\+\d{9}|\+\d{11})$/;

export type TranslationType = z.infer<ReturnType<typeof createTranslationSchema>>;
